var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aisea-operation-report-list"},[(_vm.isReportListConfigFetched)?_c('operation-report-list-page-layout-template',{attrs:{"initialSearchConditions":_vm.parsedSearchConditions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }